import React from "react";
import { useState } from 'react';


function Postcode({ nextFormStep, setLoading, setAddresses, postcode, setPostcode }) {
  const [ postcodeError, setPostcodeError ] = useState(false);
  const [ addressError, setAddressError] = useState(false);
  const [ noAddressesFound, setNoAddressesFound] = useState(false);
 
  function submitForm() {  
    if(postcode == ""){
      setPostcodeError(true);
    }
    else{
      setPostcodeError(false);
      getAddresses(
        postcode, 
        nextFormStep, 
        setLoading, 
        setAddresses, 
        setAddressError, 
        setNoAddressesFound
      );

    }
  }

  function BackToStart(){
    window.location.reload()
  }

  function ExitPage(){
    window.close();
  }

  return (
    <div>  

      <div>
        
        <a style={{"textDecoration" : "underline", "cursor" : "pointer"}}  onClick={ExitPage} >
          <svg style={{"transform" : "rotate(180deg)",  "cursor" : "pointer" }} xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><g fill='none' fill-rule='evenodd'><path fill='#00709E' fill-rule='nonzero' d='M8.371 7l-4.527 4.244a.955.955 0 0 0 .002 1.413c.42.393 1.09.391 1.506.002l5.284-4.954a.962.962 0 0 0 .311-.704.96.96 0 0 0-.311-.706L5.352 1.34a1.116 1.116 0 0 0-1.506.002.953.953 0 0 0-.002 1.413L8.37 7z'/></g></svg>
          Back
        </a>
        <br />

        <h2>Enter your postcode</h2>
        {/* <label for="postcode">Postcode</label> */}

        {addressError  &&
          <div className="validation-summary" role="alert">
            <h4>Addresses not found</h4>
            <ul role="presentation">
              <li>We can't find addresses that match '{postcode}'. There was a problem fetching the data.</li>
              <li><a href="https://beta.southglos.gov.uk/contact">Contact us about issue</a></li>
            </ul>
          </div>
        }

        {noAddressesFound && !addressError && 
          <div className="validation-summary" role="alert">
            <h4>Addresses not found</h4>
            <ul role="presentation">
              <li>We can't find addresses that match '{postcode}'. This is either because the address is not in South Gloucestershire or is not in our database yet.</li>
              <li><a href="https://beta.southglos.gov.uk/contact">Contact us about issue</a></li>
            </ul>
          </div>
        }

        {postcodeError == true &&
          <div className="validation-summary" role="alert">
            <h4>The form could not be submitted for the following reasons:</h4>
            <ul role="presentation">
              <li>Postcode is a required field</li>
            </ul>
          </div>
        }
        <input name="postcode" aria-label="Postcode" className="form-control input__small input-width--200 mbottom-10" value={postcode} onChange={(e) => setPostcode(e.target.value)} />
      </div>


      <div className="form-footer mtop-10">  
        {(noAddressesFound || addressError) &&
          <span>
            <button type="button" className="button button--blue button__small"  onClick={BackToStart} >Restart</button>&nbsp;
          </span>
        }
        <button type="button" className="button button--primary button__small"  onClick={submitForm} >Continue</button>
        <br />
        <br />

      </div>
    </div>
  );
}
export default Postcode;



function naturalSort(a, b) {
  var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?$|^0x[0-9a-f]+$|[0-9]+)/gi,
      sre = /(^[ ]*|[ ]*$)/g,
      dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
      hre = /^0x[0-9a-f]+$/i,
      ore = /^0/,
      i = function(s) {
          return naturalSort.insensitive && ('' + s).toLowerCase() || '' + s
      },
      // convert all to strings strip whitespace
      x = i(a).replace(sre, '') || '',
      y = i(b).replace(sre, '') || '',
      // chunk/tokenize
      xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0'),
      // numeric, hex or date detection
      xD = parseInt(x.match(hre)) || (xN.length != 1 && x.match(dre) && Date.parse(x)),
      yD = parseInt(y.match(hre)) || xD && y.match(dre) && Date.parse(y) || null,
      oFxNcL, oFyNcL;
  // first try and sort Hex codes or Dates
  if (yD)
      if (xD < yD) return -1;
      else if (xD > yD) return 1;
  // natural sorting through split numeric strings and default strings
  for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
      // find floats not starting with '0', string or 0 if not defined (Clint Priest)
      oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc]) || xN[cLoc] || 0;
      oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc]) || yN[cLoc] || 0;
      // handle numeric vs string comparison - number < string - (Kyle Adams)
      if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
          return (isNaN(oFxNcL)) ? 1 : -1;
      }
      // rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
      else if (typeof oFxNcL !== typeof oFyNcL) {
          oFxNcL += '';
          oFyNcL += '';
      } 
      if (oFxNcL < oFyNcL) return -1;
      if (oFxNcL > oFyNcL) return 1;
  }
  return 0;
}


function getAddresses(postcode, nextFormStep, setLoading, setAddresses, setAddressError, setNoAddressesFound){
  setLoading(true);
  fetch(`https://webapps.southglos.gov.uk/Webservices/SGC.RefuseCollectionService/RefuseCollectionService.svc/getAddresses/${postcode}`)
  .then((response) => {
    setLoading(false);
    if(response.ok){
      return response.json();
    } else{
      setAddressError(true);
    }
  })
  .then((resultData) => {
    if(resultData && resultData.length > 0){
        let addressesSorted = [];
        for(let [key,value] of Object.entries(resultData)){
        addressesSorted.push({
          uprn: value.Uprn,
          address: value.Property + " " + value.Street + " " + value.Town,
        });
        };
        addressesSorted.sort(function(a,b){
        return naturalSort(a.address,b.address)
        })
      setAddresses(addressesSorted);
      nextFormStep();
    } else {
      setNoAddressesFound(true)
    }
  })
}